// Recovered compiled webpack factory 37854. Edit this function expression; run npm run build.
(e, t, r) => {
  "use strict";
  (Object.defineProperty(t, "__esModule", { value: !0 }),
    Object.defineProperty(t, "restoreReducer", {
      enumerable: !0,
      get: function () {
        return o;
      },
    }));
  let n = r(29658),
    a = r(86343);
  function o(e, t) {
    var r;
    let { url: o, tree: i } = t,
      s = (0, n.createHrefFromUrl)(o),
      l = i || e.tree,
      u = e.cache;
    return {
      canonicalUrl: s,
      pushRef: { pendingPush: !1, mpaNavigation: !1, preserveCustomHistoryState: !0 },
      focusAndScrollRef: e.focusAndScrollRef,
      cache: u,
      prefetchCache: e.prefetchCache,
      tree: l,
      nextUrl: null != (r = (0, a.extractPathFromFlightRouterState)(l)) ? r : o.pathname,
    };
  }
  (r(87317),
    ("function" == typeof t.default || ("object" == typeof t.default && null !== t.default)) &&
      void 0 === t.default.__esModule &&
      (Object.defineProperty(t.default, "__esModule", { value: !0 }),
      Object.assign(t.default, t),
      (e.exports = t.default)));
}
